import { Injectable } from '@angular/core';
import { AbstractFeatureQueryEntity } from '@y42/feature';
import { Y42FeatureType } from '@y42/json-schema';
import { map, Observable } from 'rxjs';
import { CatalogState, CatalogUIModel } from './catalog.model';
import { CatalogStore } from './catalog.store';

@Injectable({ providedIn: 'root' })
export class CatalogQuery extends AbstractFeatureQueryEntity<CatalogState, CatalogUIModel> {
  constructor(protected readonly store: CatalogStore) {
    super({
      store,
      featureType: Y42FeatureType.Catalog,
      toUIModel: (storeModel) => ({
        featureType: Y42FeatureType.Catalog,
        ...storeModel,
      }),
    });
  }

  readonly active$: Observable<CatalogUIModel | undefined> = this.selectActive().pipe(
    map((active) => (active ? this.toUIModel(active) : undefined)),
  );
  readonly items$: Observable<CatalogUIModel[]> = this.selectAll().pipe(
    map((items) => items.map((item) => this.toUIModel(item))),
  );
  readonly toListViewModel = (item: CatalogUIModel) => [item];
}
